import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import './ModalWindow.css';
import {getYears,getStatuses,getBandsWithFilters,getEventsType,getStarBands,saveEventType,
  getTotalSongDuration, addPerformance, addEvent,
  fetchConcertVersion, getEventDuration, 
  getStarPerformanceDuration, getAchievements, AchievementOption
} from '../ModalApi/ModalApi';
import { useLocation, useNavigate } from 'react-router-dom';
interface ModalWindowProps  {
  onClose: () => void;
  concertId: number;
}
const statusLabels: Record<string, string> = {
  tak: "zaakceptowane",
  nie: "niezaakceptowane",
};
const ModalWindow: React.FC<ModalWindowProps > = ({
  onClose,
  concertId,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState('');
  const [years, setYears] = useState<string[]>([]);
  const [statuses, setStatuses] = useState<string[]>([]); 

  const DEFAULT_YEAR = new Date().getFullYear().toString();
  const DEFAULT_STATUS = "tak";

  const [selectedYear, setSelectedYear] = useState<string>(DEFAULT_YEAR);
  const [selectedStatus, setSelectedStatus] = useState<string>(DEFAULT_STATUS);
  const [selectedTeam, setSelectedTeam] = useState<string | null>(null);
  const [eventDuration, setEventDuration] = useState<number | ''>('');
  const [showForm, setShowForm] = useState(false); 
  const [eventTypeName, setEventTypeName] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventTime, setEventTime] = useState(0);
  const [showNewEventForm, setShowNewEventForm] = useState(false);
  const [eventColor, setEventColor] = useState("#ff8800"); 
  const [items, setItems] = useState<string[]>([]);
  const [addButtonVisible, setAddButtonVisible] = useState(false);
  const [addButtonLabel, setAddButtonLabel] = useState("");
  const [totalSongDuration, setTotalSongDuration] = useState<number>(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [catName, setCatname] = useState<string>('');
  const eventNameInputRef = useRef<HTMLInputElement>(null);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const isModalOpen = location.pathname.includes("/add-event");
  const isBulkMode = new URLSearchParams(location.search).get('mode') === 'bulk';
  const defaultAchievementFilter = 'wszystkie';
  const defaultCategoryFilter = 'wszystkie';
  const [achievementOptions, setAchievementOptions] = useState<AchievementOption[]>([]);
  const [selectedAchievementFilter, setSelectedAchievementFilter] = useState<string>(defaultAchievementFilter);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState<string>(defaultCategoryFilter);
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
  const [isBulkSubmitting, setIsBulkSubmitting] = useState(false);
  const [insertBeforePreviousTeam, setInsertBeforePreviousTeam] = useState(false);
  const ADDITIONAL_MINUTES = 2; // Dodatkowy czas na występ w minutach

  const handleAddNewEventType = () => {
    setShowNewEventForm(true);
    setItems([]);
  };

  
  useEffect(() => {
    if (isModalOpen) {
      const achievementFilter = isBulkMode ? selectedAchievementFilter : defaultAchievementFilter;
      getBandsWithFilters(axiosPrivate, selectedYear, selectedStatus, setItems, achievementFilter);
      setSelectedCategory("Zespoły");
      setCatname("Nazwa zespołu");
    }
  }, [isModalOpen, axiosPrivate, selectedYear, selectedStatus, isBulkMode, selectedAchievementFilter]);

  useEffect(() => {
    if (isModalOpen && isBulkMode) {
      getAchievements(axiosPrivate, setAchievementOptions);
    }
  }, [isModalOpen, isBulkMode, axiosPrivate]);

  useEffect(() => {
    if (selectedCategory === "Zespoły") {
      getYears(axiosPrivate, setYears);
      getStatuses(axiosPrivate, setStatuses);
      const achievementFilter = isBulkMode ? selectedAchievementFilter : defaultAchievementFilter;
      getBandsWithFilters(axiosPrivate, selectedYear, selectedStatus, setItems, achievementFilter);
    }
  }, [selectedYear, selectedStatus, isModalOpen, selectedCategory, axiosPrivate, isBulkMode, selectedAchievementFilter]);

  const handleSubmitNewEvent = async () => {
    if (!eventTypeName || !eventColor) {
      alert('Wszystkie pola muszą być wypełnione.');
      return;
    } 
    const eventPayload = {
      title: eventTypeName,
      color: eventColor,
      time: eventTime
    };
    await saveEventType(
      axiosPrivate,
      eventPayload,
      () => {
        alert('Wydarzenie zostało zapisane pomyślnie!');
        setShowNewEventForm(false);
        setEventTypeName("");
        setEventColor("#ff8800");
        setEventTime(0);
        getEventsType(axiosPrivate, setItems);
      },
      () => {
        alert('Nie udało się zapisać wydarzenia. Spróbuj ponownie.');
      }
    );
  }; 
  const handlecatname = (category: string) => {
    if (category === "Zespoły") {
      setCatname("Nazwa zespołu");
    } else if (category === "Gwiazdy") {
      setCatname("Nazwa zespołu");
    } else {
      setCatname("Gotowe wydarzenia");
    }
  };
  
  const handleYearChange = (event: SelectChangeEvent) => {
    setSelectedYear(event.target.value); 
  };

  const handleStatusChange = (event: SelectChangeEvent) => {
  setSelectedStatus(event.target.value);
  };

  const handleAchievementChange = (event: SelectChangeEvent) => {
    setSelectedAchievementFilter(event.target.value);
  };

  const handleBandCategoryChange = (event: SelectChangeEvent) => {
    setSelectedCategoryFilter(event.target.value);
  };

  const toggleCheckedItem = (item: string) => {
    setCheckedItems(prev => {
      const next = new Set(prev);
      if (next.has(item)) next.delete(item);
      else next.add(item);
      return next;
    });
  };

  const handleAddAllChecked = async () => {
    setIsBulkSubmitting(true);
    const teamsToAdd = Array.from(checkedItems);
    let successCount = 0;
    let failCount = 0;
    let previousAddedConcertOrder: number | null = null;
    try {
      for (const team of teamsToAdd) {
        try {
          const latestVersion = await fetchConcertVersion(axiosPrivate, concertId);
          // pobierz czas trwania dla każdego zespołu
          let duration: number = 0;
          await getTotalSongDuration(axiosPrivate, team, (d) => {
            duration = Number(d) + ADDITIONAL_MINUTES;
          });
          if (!duration || duration <= 0) duration = ADDITIONAL_MINUTES;
          await addPerformance(
            axiosPrivate,
            team,
            duration,
            false,
            concertId,
            latestVersion,
            insertBeforePreviousTeam && previousAddedConcertOrder !== null ? previousAddedConcertOrder : null,
            insertBeforePreviousTeam,
            (response) => {
              successCount++;
              if (insertBeforePreviousTeam && typeof response?.nrKoncertu === 'number') {
                previousAddedConcertOrder = response.nrKoncertu;
              }
            },
            () => { failCount++; }
          );
        } catch {
          failCount++;
        }
      }
    } finally {
      setIsBulkSubmitting(false);
      setCheckedItems(new Set());
      alert(`Dodano: ${successCount}, błędy: ${failCount}`);
      if (successCount > 0) onClose();
    }
  };

  const NavigateToAddingStars = () =>{
    navigate('/artists1');
  }
  
  const handleCategoryChange = async (category: string) => {
    setSelectedCategory(category);
    setSearchQuery("");
    setSelectedTeam(null);
    setEventDuration("");
    setShowForm(false);
    setShowNewEventForm(false);
    handlecatname(category); 
    const categoryActions: Record<string, () => Promise<void>> = {
      Zespoły: async () => {
        const achievementFilter = isBulkMode ? selectedAchievementFilter : defaultAchievementFilter;
        await getBandsWithFilters(axiosPrivate, selectedYear, selectedStatus, setItems, achievementFilter);
        setAddButtonVisible(false);
        setAddButtonLabel("");
      },
      Gwiazdy: async () => {
        await getStarBands(axiosPrivate, setItems);
        setAddButtonVisible(true);
        setAddButtonLabel("Nowa gwiazda");
      },
      Inne: async () => {
        await getEventsType(axiosPrivate, setItems);
        setAddButtonVisible(true);
        setAddButtonLabel("Nowy Typ Wydarzenia");
      },
    };
  
    if (categoryActions[category]) {
      await categoryActions[category]();
    } else {
      setItems([]);
      setAddButtonVisible(false);
      setAddButtonLabel("");
    }
  };

  const fetchAndSetDuration = useCallback(async (team: string) => {
    if (selectedCategory === "Gwiazdy") {
      await getStarPerformanceDuration(axiosPrivate, setEventDuration);
  } else if(selectedCategory === "Inne") {
    await getEventDuration(axiosPrivate, team, setEventDuration);
  }
  else{
    await getTotalSongDuration(axiosPrivate, team, (duration) => {
      const numericDuration = Number(duration);
      setTotalSongDuration(numericDuration);
      setEventDuration(numericDuration + ADDITIONAL_MINUTES);
    });
  }
  }, [axiosPrivate, selectedCategory]);

  const handleTeamClick = async (team: string) => {
    setSelectedTeam(team);
    setEventDuration("");
    await fetchAndSetDuration(team); 
  };

  useEffect(() => {
    if (selectedTeam) {
      fetchAndSetDuration(selectedTeam);
    }
  }, [fetchAndSetDuration,selectedTeam]);

  const handleCancel = () => {
    setSelectedTeam(null);
    setEventDuration("");
  };

  const handleAddNewEvent = async () => {
    if (isSubmitting || !selectedTeam || !eventDuration) {
      alert("brak dnaych");
      return;
    }
    try {
      // Pobierz najnowszą wersję koncertu
      const latestVersion = await fetchConcertVersion(axiosPrivate, concertId);
  
      await addEvent(
        axiosPrivate,
        eventName,
        selectedTeam,
        eventDuration,
        concertId,
        latestVersion,
        (data) => {
        alert('Dodano pomyślnie wydarzenie');
        console.log('Wydarzenie dodane pomyślnie:', data);
        setSelectedTeam(null);
        setEventDuration('');
        onClose();
        },
        (error) => {
          console.error('Błąd podczas dodawania wydarzenia:', error);
        }
      );
    } catch (error) {
      console.error("Błąd podczas pobierania wersji koncertu:", error);
      alert("Nie udało się uzyskać wersji koncertu. Spróbuj ponownie.");
    }
  }
  const handleSavePerformance = async () => {
    if (isSubmitting || !selectedTeam || !eventDuration) {
      alert(`Wybierz ${selectedCategory === 'Gwiazdy' ? 'gwiazdę' : 'zespół'} i podaj czas trwania!`);
      return;
    }
    setIsSubmitting(true);
    try {
      const latestVersion = await fetchConcertVersion(axiosPrivate, concertId);
      await addPerformance(
        axiosPrivate,
        selectedTeam,
        eventDuration,
        selectedCategory === 'Gwiazdy',
        concertId,
        latestVersion,
        null,
        false,
        () => {
          alert(`Występ ${selectedCategory === 'Gwiazdy' ? 'gwiazdy' : 'zespołu'} ${selectedTeam} został dodany do koncertu!`);
          //fetchAndUpdateGrid();
          setSelectedTeam(null);
          setEventDuration('');
          onClose();
        },
        (error) => {
          alert(`Nie udało się dodać występu ${selectedCategory === 'Gwiazdy' ? 'gwiazdy' : 'zespołu'}. Spróbuj ponownie.`);
          console.error(error);
        }
      );
    } catch (error) {
      console.error(`Błąd podczas dodawania występu ${selectedCategory === 'Gwiazdy' ? 'gwiazdy' : 'zespołu'}:`, error);
    } finally {
      setIsSubmitting(false); // Odblokuj przycisk po zakończeniu operacji
    }
  };
  useEffect(() => {
    if (selectedCategory === "Inne" && selectedTeam) {
      setEventName(`${selectedTeam} `); // ustaw nazwę + spacja
      setTimeout(() => {
        if (eventNameInputRef.current) {
          const length = eventNameInputRef.current.value.length;
          eventNameInputRef.current.focus();
          eventNameInputRef.current.setSelectionRange(length, length); // Kursor na końcu
        }
      }, 0);
    }
  }, [selectedTeam, selectedCategory]);

  const filteredItems = useMemo(
    () => items.filter((item) => item.toLowerCase().includes(searchQuery.toLowerCase())),
    [items, searchQuery]
  );

  const hasVisibleItems = filteredItems.length > 0;
  const allVisibleChecked = hasVisibleItems && filteredItems.every((item) => checkedItems.has(item));

  const toggleAllVisibleChecked = () => {
    setCheckedItems((prev) => {
      const next = new Set(prev);
      const shouldUncheckVisible = filteredItems.length > 0 && filteredItems.every((item) => next.has(item));

      filteredItems.forEach((item) => {
        if (shouldUncheckVisible) {
          next.delete(item);
        } else {
          next.add(item);
        }
      });

      return next;
    });
  };

    return (
      <div className="custom-modal">
        <div className='custom-modal-content'>
          <div className='modal-top'>
            <div className="modal-header">
              <div className="modal-header-right">
                <span className="modal-close-button" onClick={onClose}>&times;</span>
              </div>
            </div>
            {isBulkMode && selectedCategory === "Zespoły" && !selectedTeam && !showNewEventForm && (
              <div className="modal-bulk-actions">
                <label className="bulk-order-toggle">
                  <input
                    type="checkbox"
                    checked={insertBeforePreviousTeam}
                    onChange={(e) => setInsertBeforePreviousTeam(e.target.checked)}
                    disabled={isBulkSubmitting}
                  />
                  Ustawiaj zespół (oprócz pierwszego)
                </label>
                <button
                  className="custom-modal-button bulk-toggle-btn"
                  onClick={toggleAllVisibleChecked}
                  disabled={isBulkSubmitting || !hasVisibleItems}
                >
                  {allVisibleChecked ? 'Odznacz widoczne' : 'Zaznacz widoczne'}
                </button>
                <button
                  className="custom-modal-button bulk-add-btn"
                  onClick={handleAddAllChecked}
                  disabled={isBulkSubmitting || checkedItems.size === 0}
                >
                  {isBulkSubmitting ? 'Dodawanie...' : `Dodaj zaznaczone (${checkedItems.size})`}
                </button>
              </div>
            )}
            <div className="modal-top-controls">
              <div className="modal-top-left-controls">

                <div className='modal-search'>
                  <p className="filter-label">Wybierz dodawaną aktywność:</p>
                  <input
                    className="modal-input"
                    type="text"
                    placeholder="Szukaj..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                {selectedCategory === "Zespoły" && (
                <>
                <div className="year-selector">
                  <p className="filter-label">Wybierz Rok:</p>
                  <Select
                    value={years.includes(selectedYear) ? selectedYear : DEFAULT_YEAR}
                    onChange={handleYearChange}
                    displayEmpty
                    fullWidth
                    sx={{
                      backgroundColor: "#222222", 
                      border: "1px solid #ff8800", 
                      color: "#ffffff", 
                      "& .MuiSelect-icon": { color: "#ff8800" }, 
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" }, 
                    }}
                  >
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="status-selector">
                  <p className="filter-label">Wybierz status:</p>
                  <Select
                    value={statuses.includes(selectedStatus) ? selectedStatus : ""}
                    onChange={handleStatusChange}
                    displayEmpty
                    fullWidth
                    sx={{
                      backgroundColor: "#222222", 
                      border: "1px solid #ff8800", 
                      color: "#ffffff", 
                      "& .MuiSelect-icon": { color: "#ff8800" }, 
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" }, 
                    }}
                  >
                    {statuses.map((status) => (
                      <MenuItem key={status} value={status}>
                        {statusLabels[status] || status}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                {isBulkMode && (
                <div className="bulk-extra-filters">
                  <div className="achievement-selector">
                    <p className="filter-label">Wybierz osiągnięcie:</p>
                    <Select
                      value={selectedAchievementFilter}
                      onChange={handleAchievementChange}
                      displayEmpty
                      fullWidth
                      sx={{
                        backgroundColor: "#222222",
                        border: "1px solid #ff8800",
                        color: "#ffffff",
                        "& .MuiSelect-icon": { color: "#ff8800" },
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      }}
                    >
                      <MenuItem value={defaultAchievementFilter}>{defaultAchievementFilter}</MenuItem>
                      {achievementOptions.map((option) => (
                        <MenuItem key={option.idOsiagniecia} value={String(option.idOsiagniecia)}>
                          {option.nazwa}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div className="category-selector">
                    <p className="filter-label">Wybierz kategorię:</p>
                    <Select
                      value={selectedCategoryFilter}
                      onChange={handleBandCategoryChange}
                      displayEmpty
                      fullWidth
                      sx={{
                        backgroundColor: "#222222",
                        border: "1px solid #ff8800",
                        color: "#ffffff",
                        "& .MuiSelect-icon": { color: "#ff8800" },
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      }}
                    >
                      <MenuItem value={defaultCategoryFilter}>{defaultCategoryFilter}</MenuItem>
                    </Select>
                  </div>
                </div>
                )}
                </>
                )}
              </div>
              {!isBulkMode && (
                <div className="modal-buttons">
                  <button className="custom-modal-button" onClick={() => handleCategoryChange("Zespoły")}>Zespoły</button>
                  <button className="custom-modal-button" onClick={() => handleCategoryChange("Gwiazdy")}>Gwiazdy</button>
                  <button className="custom-modal-button" onClick={() => handleCategoryChange("Inne")}>Inne</button>
                </div>
              )}
            </div>
          </div>
          <hr className="modal-divider" />
          {!showForm && (
          <>
          <div className='modal-main'>
          {!selectedTeam ? (
            showNewEventForm ? (
            <div className="modal-new-event-form">
              <h3>Dodaj inne wydarzenie</h3>
              <div className="form-container">
                <div className="row">
                  <div className="form-group">
                    <label>Nazwa wydarzenia</label>
                    <input
                      type="text"
                      value={eventTypeName}
                      onChange={(e) => setEventTypeName(e.target.value)}
                      className="modal-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>Przewidywany czas trwania</label>
                    <input
                      type="number"
                      value={eventTime}
                      onChange={(e) => setEventTime(Number(e.target.value))}
                      className="modal-input"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group">
                    <label>Wybierz kolor</label>
                    <input
                      type="text"
                      value={eventColor}
                      onChange={(e) => setEventColor(e.target.value)}
                      className="modal-input"
                    />
                  </div>
                  <div className="form-group">
                    <label>kolor</label>
                    <div className="color-block" style={{ backgroundColor: eventColor || "#222222" }}></div>
                  </div>
                </div>
              </div>
              <div className="modal-event-buttons">
                <button onClick={handleSubmitNewEvent} className="custom-modal-button">
                  Dodaj
                </button>
              </div>
            </div>
            ): (
                <>
                  <p className="modal-list-header">{catName}</p>
                  <div className="modal-list">
                    {filteredItems.map((item, index) => (
                      <div
                        key={index}
                        className={`modal-list-item${isBulkMode ? ' modal-list-item--bulk' : ''}`}
                        onClick={() => isBulkMode ? toggleCheckedItem(item) : handleTeamClick(item)}
                      >
                        {isBulkMode && (
                          <input
                            type="checkbox"
                            className="bulk-checkbox"
                            checked={checkedItems.has(item)}
                            onChange={() => toggleCheckedItem(item)}
                            onClick={(e) => e.stopPropagation()}
                          />
                        )}
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                  {addButtonVisible && (
                    <div className="modal-buttons-add">
                      <button
                        onClick={() => {
                          if (selectedCategory === "Inne") {
                            handleAddNewEventType();
                          } else if (selectedCategory === "Gwiazdy") {
                            NavigateToAddingStars();
                          }
                        }}
                      >
                        {addButtonLabel}
                      </button>
                    </div>
                  )}
                </>
              )
            ) : (
              <>
              <div className='modal-scrollable'>
                <div className="modal-team-headers">
                  <h2>{selectedTeam}</h2>
                </div>
                <div className="modal-team-controls">
                  <p className="modal-team-paragraph">Czas trwania wydarzenia (w minutach)</p>
                  <input
                    className="modal-input"
                    type="number"
                    value={eventDuration === 0 ? "" : eventDuration}
                    onChange={(e) => {
                      const value = e.target.value === "" ? "" : Math.max(1, Number(e.target.value)); // Minimalna wartość to 1
                      setEventDuration(value === "" ? "" : value); // Pozwala na wyczyszczenie pola i wymusza minimalną wartość
                    }}
                    placeholder="Czas w minutach"
                  />
                  {selectedCategory === "Inne" && (
                    <>
                      <p className="modal-team-paragraph" style={{ marginTop: '20px' }}>Nazwa wydarzenia:</p>
                      <input
                        className="modal-input"
                        type="text"
                        ref={eventNameInputRef}
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                        placeholder="Podaj nazwę wydarzenia"
                      />
                    </>
                  )}
                  <div className="modal-team-buttons">
                    <button
                      className="custom-modal-button"
                      onClick={() => {
                        if (selectedCategory === 'Inne') {
                          handleAddNewEvent();
                        } else {
                          handleSavePerformance();
                        }
                      }}
                      disabled={isSubmitting}
                    >
                      Dodaj
                    </button>
                    <button
                      className="custom-modal-button"
                      onClick={handleCancel}
                    >
                      Anuluj
                    </button>
                  </div>
                </div>
              </div>
              </>
            )}
          </div>
          </>
          )}
        </div>
      </div>
    );  
};
export default ModalWindow;